export default __webpack_public_path__ + "static/media/banner_home.c26dd210.png";